import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';

import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(),

    // ✅ FIX: quando navighi cambia pagina => torna su (scroll top)
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',   // sempre su quando cambi route
        anchorScrolling: 'enabled',         // se usi #id (ancore) funziona
      })
    ),

    provideClientHydration(withEventReplay()),
  ],
};
